import { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ExpandMore, InsertPhoto, CameraAlt } from "@mui/icons-material";
import { unwrapResult } from "@reduxjs/toolkit";
import { createJunkRemovalItems, getJunkRemoval, updateJunkRemoval } from "../../redux/action/junk-removal";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

export interface JunkRemovalDetailsProps {
  onNext: (junkRemovalId?: string) => void;
  onBack: () => void;
}

const JunkRemovalType: React.FC<JunkRemovalDetailsProps> = ({ onNext, onBack }) => {
  const theme = useTheme();
  const [description, setDescription] = useState("");
  const [selectedRemovalType, setSelectedRemovalType] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
const {canonicalId} = useParams()
const [junkRemovalId, setJunkRemovalId] = useState(null);

useEffect(()=>{
  if(canonicalId){
    dispatch<any>(getJunkRemoval(canonicalId))
    .then(unwrapResult)
    .then((res: any) => {
      setJunkRemovalId(res.id)
    })
    .catch((err: any) => {
      console.error("Failed to fetch move data:", err);
    });
  }
},[])
  const removalOptions = [
    "Single Item",
    "Multiple Items",
    "Room of Items",
    "Full Cleanout",
  ];

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleRemovalTypeSelect = (option: string) => {
    setSelectedRemovalType(option);
    setIsDropdownOpen(false); 
  };
const handleSubmit = () =>{
  const sendData = { 
    removal_type: selectedRemovalType,
    canonical_id:canonicalId
  }
  dispatch<any>(updateJunkRemoval(sendData))
  .then(unwrapResult)
  .then((res: any) => {
    const newCanonicalId = res.canonical_id;
    onNext(newCanonicalId)
  })
  .catch((err: any) => {
    console.error("Failed to fetch move data:", err);
  });

  const data = { 
    removal_item_name: description,
    junkRemovalId:junkRemovalId,
  }
  dispatch<any>(createJunkRemovalItems(data))
  .then(unwrapResult)
  .then((res: any) => {
  })
  .catch((err: any) => {
    console.error("Failed to fetch move data:", err);
  });
}
  return (
    <Container
      sx={{
        width: "100%",
        height: isMobile ? "93vh" : "80vh",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        padding: isMobile ? "20px" : "20px",
        background: "#f2f0f0",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Box
          sx={{ display: "flex", justifyContent: "space-between", cursor: "pointer", py: 2 }}
          onClick={handleDropdownToggle}
        >
          <Typography fontSize={16} fontWeight={600}>
            Removal Type {selectedRemovalType && `: ${selectedRemovalType}`}
          </Typography>
          <IconButton>
            <ExpandMore color="primary" />
          </IconButton>
        </Box>

        {isDropdownOpen && (
          <Box sx={{ paddingLeft: "16px" }}>
            {removalOptions.map((option) => (
              <Box
                key={option}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 0",
                  cursor: "pointer",
                }}
                onClick={() => handleRemovalTypeSelect(option)}
              >
                <Typography fontSize={14} fontWeight={400}>
                  {option}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        <Divider sx={{ background: "#D3D3D3", mb: 2 }} />
        <Box py={3}>
          <Typography fontSize={14} fontWeight={500} color="text.secondary" mb={1}>
            Briefly describe what is being removed (300 characters max).
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Enter details..."
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Box>

        <Divider sx={{ background: "#D3D3D3", mb: 2 }} />
        <Box display="flex" justifyContent="space-between" alignItems="center" py={2} borderBottom={1}>
          <Typography fontSize={14} fontWeight={500} color="text.secondary">
            Upload images of items/rooms
          </Typography>
          <Box>
            <input type="file" accept="image/*" style={{ display: "none" }} />
            <IconButton>
              <InsertPhoto color="primary" />
            </IconButton>
            <IconButton>
              <CameraAlt color="primary" />
            </IconButton>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          paddingBottom: "20px",
          marginTop: "20px",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            borderRadius: "20px",
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            padding: isMobile ? "8px 20px" : "8px 45px",
            textTransform: "none",
            fontSize: isMobile ? "12px" : "14px",
            fontWeight: "600",
          }}
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          variant="contained"
          sx={{
            borderRadius: "20px",
            backgroundColor: theme.palette.primary.main,
            color: "#fff",
            padding: isMobile ? "8px 20px" : "8px 45px",
            textTransform: "none",
            fontSize: isMobile ? "12px" : "14px",
            fontWeight: "600",
            "&:hover": { backgroundColor: "#357ABD" },
          }}
          onClick={handleSubmit}
        >
          Continue
        </Button>
      </Box>
    </Container>
  );
};

export default JunkRemovalType;
